import { sleep } from "@jog/shared"
import { Properties, TweakwiseItem } from "@jog/types"
import {
    Dispatch,
    PropsWithChildren,
    SetStateAction,
    createContext,
    useCallback,
    useContext,
    useRef,
    useState,
} from "react"

interface LastListerState {
    path: string
    setPath: Dispatch<SetStateAction<string>>
    recordLister: (tweakwiseProperties: Properties["pageurl"], item: TweakwiseItem["itemno"]) => void
    checkScroll: (tweakwiseProperties: Properties, items: TweakwiseItem[]) => void
}

const LastListerContext = createContext<LastListerState>({
    path: "",
    setPath: () => {},
    recordLister: () => {},
    checkScroll: () => {},
})

export const LastListerProvider = ({ children }: PropsWithChildren) => {
    const [path, setPath] = useState("")
    const state = useRef<{ pageurl: string; itemno: string } | null>(null)
    const recordLister = (pageurl: Properties["pageurl"], itemno: TweakwiseItem["itemno"]) => {
        state.current = { pageurl, itemno }
    }
    const checkScroll = useCallback(async (properties: Properties, items: TweakwiseItem[]) => {
        if (!state.current) return
        const item = items.find(({ itemno }) => itemno === state.current!.itemno)
        if (item && properties.pageurl === state.current.pageurl) {
            await sleep(500)
            const element = document.querySelector(`#item_${item.itemno}`)
            if (element) element.scrollIntoView({ behavior: "smooth", block: "center" })
        }
        state.current = null
    }, [])
    return (
        <LastListerContext.Provider value={{ path, setPath, recordLister, checkScroll }}>
            {children}
        </LastListerContext.Provider>
    )
}

export const useLastLister = () => useContext(LastListerContext)!
